// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2S_en","importantInfo":"styles_importantInfo__1pdaS"};